<template>
    <div
        class="mx-auto lg:mx-0 lg:max-w-none relative"
        :class="[
            index == 0 ? 'lg:col-start-1 lg:col-end-3' : '',
            index == 1
                ? 'mt-10 lg:mt-0 max-w-lg lg:col-start-3 lg:col-end-6 lg:row-start-1 lg:row-end-4'
                : 'max-w-md lg:row-start-2 lg:row-end-3',
            index == 2 ? 'mt-10 lg:mt-0 lg:col-start-6 lg:col-end-8' : '',
        ]"
    >
        <template v-if="index != 1">
            <LoopBadge :pricing="pricing" :variant="variant" />
            <div
                :style="{
                    'border-color': variant.highlight ? pricing.highlightColor : 'transparent',
                }"
                class="h-full flex flex-col overflow-hidden rounded-lg shadow-lg border-2 lg:rounded-none"
                :class="[
                    index == 0 ? 'lg:border-r-0 lg:rounded-l-lg' : '',
                    index == 1 ? '' : '',
                    index == 2 ? 'lg:border-l-0 lg:rounded-r-lg' : '',
                ]"
            >
                <LoopMain :pricing="pricing" :variant="variant" :index="index" />
            </div>
        </template>
        <template v-else>
            <LoopMain :pricing="pricing" :variant="variant" :index="index" />
        </template>
    </div>
</template>

<script>
import LoopBadge from "./LoopBadge.vue";
import LoopMain from "./LoopMain.vue";

export default {
    name: "LoopCard",
    props: {
        pricing: Object,
        variant: Object,
        index: Number,
    },
    components: {
        LoopBadge,
        LoopMain,
    },
};
</script>
